import { ConfigProvider } from "antd";
import { type FC } from "react";
import { BrowserRouter } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { AppLayout } from "../@bloodline";
import { Toaster } from "../components/ui/toaster";
import { AuthProvider } from "./auth/AuthProvider";
import { AppRoutes } from "./router";

const queryClient = new QueryClient();

const App: FC = () => {
  return (
    <AuthProvider>
      <ConfigProvider
        componentSize="large"
        theme={{
          cssVar: {
            prefix: "antd",
          },
          token: {
            screenXS: 480,
            screenXSMin: 480,
            screenSM: 576,
            screenSMMin: 576,
            screenMD: 768,
            screenMDMin: 768,
            screenLG: 992,
            screenLGMin: 992,
            screenXL: 1200,
            screenXLMin: 1200,
            screenXXL: 1600,
            screenXXLMin: 1600,
            screenXSMax: 575,
            screenSMMax: 767,
            screenMDMax: 991,
            screenLGMax: 1199,
            screenXLMax: 1599,
            fontSizeSM: 20,
          },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AppLayout>
              <AppRoutes />
            </AppLayout>
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
          <Toaster />
        </QueryClientProvider>
      </ConfigProvider>
    </AuthProvider>
  );
};

export default App;
